import { store }                from '../../index';
import { SET_COMPONENTS_STATE } from 'actions';
import { objType }              from 'types';

const zeroInput = () => { 

    const state              = store.getState();
    const componentsState    = state.components;
    const setComponentsState = (payload: objType) => store.dispatch(SET_COMPONENTS_STATE(payload))

    setComponentsState({
        ...componentsState,
        animateComp: true
    })

    setTimeout(() => {
        setComponentsState({
            ...componentsState,
            textInput:   '',
          //  success:     false,
            animateComp: false,
           // failurCount: 0,
            tens: {
                isOver: false,
                value:   -1
            },
            units: { 
                isOver: false,
                value:  -1
            }
        })
    },250)

    
    
}

export default zeroInput;
